import { render, staticRenderFns } from "./AssistantModalDom.vue?vue&type=template&id=42f8c705&scoped=true&"
import script from "./AssistantModalDom.vue?vue&type=script&lang=ts&"
export * from "./AssistantModalDom.vue?vue&type=script&lang=ts&"
import style0 from "./AssistantModalDom.vue?vue&type=style&index=0&id=42f8c705&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f8c705",
  null
  
)

export default component.exports